/**
 * BitacoraMiniPost Component (Tier B)
 *
 * Compact one-line social-feed entry for low-weight events (expenses,
 * approvals, assignments). No image, no expand, no click behavior.
 *
 * @module components/timeline/BitacoraMiniPost
 */

import React from 'react';
import PropTypes from 'prop-types';
import TaskAssigneeAvatar from '../tasks/shared/TaskAssigneeAvatar';
import { humanizeAction, formatRelativeTime } from '../../services/timelineService';

const BitacoraMiniPost = ({ event }) => {
  const assignee = {
    id: event.user_id,
    full_name: event.user_name || 'Sistema',
  };

  return (
    <div className="bitacora-mini-post">
      <div className="bitacora-mini-post-avatar">
        <TaskAssigneeAvatar assignee={assignee} size="sm" />
      </div>

      <div className="bitacora-mini-post-text">
        <strong>{event.user_name || 'Sistema'}</strong>
        <span className="bitacora-mini-post-dot"> · </span>
        {formatRelativeTime(event.timestamp)}
        <span className="bitacora-mini-post-dot"> · </span>
        <span className="bitacora-mini-post-action">{humanizeAction(event)}</span>
        {event.metadata?.task_number && (
          <>
            <span className="bitacora-mini-post-dot"> · </span>
            <span className="bitacora-mini-post-task">{event.metadata.task_number}</span>
          </>
        )}
      </div>
    </div>
  );
};

BitacoraMiniPost.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    event_type: PropTypes.string,
    user_id: PropTypes.string,
    user_name: PropTypes.string,
    timestamp: PropTypes.string,
    amount: PropTypes.number,
    metadata: PropTypes.object,
  }).isRequired,
};

export default BitacoraMiniPost;
